<template>
  <div v-if="loading"
       class="overlay-layer card-rounded bg-dark bg-opacity-20">
   <div class="spinner-border text-primary" role="status"></div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  }
}
</script>
